<template>
  <div class="card">
    <div class="card-header">
      <div class="card-header-title">
        <div class="title is-6 is-marginless">
          Header Links <span class="tag">Προσθήκη Header Link</span>
        </div>
      </div>
      <div class="card-header-icon">
        <RouterLink
          :to="{ name: 'content.home.header-links.list' }"
          class="button"
        >
          <span class="icon is-small"><i class="fa fa-list"/></span>
          <span>Λίστα</span>
        </RouterLink>
      </div>
    </div>

    <form @submit.prevent="submit">
      <div class="card-content">
        <div class="field">
          <label class="label">Τίτλος (EL) *</label>
          <div class="control">
            <input
              v-validate="'required'"
              v-model.trim="form.title_el"
              class="input"
              type="text"
              name="title_el"
            />
            <p v-show="errors.has('title_el')" class="help is-danger">
              Εισάγετε τίτλο στα Ελληνικά
            </p>
          </div>
        </div>

        <div class="field">
          <label class="label">Αγγλικός Τίτλος *</label>
          <div class="control">
            <input
              v-validate="'required'"
              v-model.trim="form.title_en"
              class="input"
              type="text"
              name="title_en"
            />
            <p v-show="errors.has('title_en')" class="help is-danger">
              Εισάγετε τίτλο στα Αγγλικά
            </p>
          </div>
        </div>

        <div class="field">
          <label class="label">Link (URL) *</label>
          <div class="control">
            <input
              v-validate="'required|url'"
              v-model.trim="form.link"
              class="input"
              type="text"
              name="link"
              placeholder="https://..."
            />
            <p v-show="errors.has('link')" class="help is-danger">
              Εισάγετε έγκυρο link (URL)
            </p>
          </div>
        </div>

        <div class="field">
          <label class="label" title="Μέγιστο 3 ενεργοί σύνδεσμοι">
            Εμφανές *
          </label>

          <div class="control">
            <ToggleButton
              :sync="true"
              :value="form.is_active"
              :color="{ checked: '#22A684', unchecked: '#ff3860' }"
              :width="30"
              :height="15"
              @change="updateActive"
            />
          </div>
          <p class="help">
            Μέγιστο 3 ενεργοί σύνδεσμοι επιτρέπονται.
          </p>
        </div>
      </div>

      <div class="card-footer">
        <FormSubmit :is-saving="isSaving" @reset="reset" />
      </div>
    </form>
  </div>
</template>

<script>
import AddItem from '@/views/components/AddItem';
import request from '@/utils/request';

export default {
  name: 'HeaderLinksAdd',
  extends: AddItem,

  data() {
    return {
      form: {
        title_el: '',
        title_en: '',
        link: '',
        is_active: false,
      },
      isSaving: false,
    };
  },

  methods: {
    async submit() {
      try {
        const isValid = await this.$validator.validateAll();
        if (!isValid) throw new Error('Client-side validation failed');

        this.isSaving = true;

        const { data } = await request.post('/home/header-links', this.form);

        this.isSaving = false;

        if (data?.error) {
          // surface BE rule (e.g., “Maximum of 3 active header links allowed”)
          this.$notify({
            type: 'error',
            title: 'Αποτυχία',
            text: data.message || 'To αίτημα απέτυχε',
          });
          return;
        }

        this.$router
          .push({ name: 'content.home.header-links.list' })
          .catch(err => console.log(err));

        this.$notify({
          type: 'success',
          title: 'Επιτυχία',
          text: 'Ο σύνδεσμος αποθηκεύτηκε',
        });
      } catch (err) {
        this.isSaving = false;
        this.$notify({
          type: 'error',
          title: 'Αποτυχία',
          text:
            err?.response?.data?.message || err?.message || 'To αίτημα απέτυχε',
        });
      }
    },

    reset() {
      this.form = {
        title_el: '',
        title_en: '',
        link: '',
        is_active: false,
      };
      this.$validator.reset();
    },

    updateActive({ value }) {
      this.form.is_active = !!value;
    },
  },
};
</script>
